/**
 * Kanoniske ruteadresser for sidene som lastes etterspurt (lazy).
 *
 * Adressene bodde tidligere som statiske felter på selve sidekomponentene
 * (`ReportsPage.path`). Det virker helt til noen skal *lenke* til siden:
 * `import { ReportsPage } from "…"` bare for å lese `.path` drar hele siden
 * med alle avhengighetene sine inn i hovedbunten, og da hjelper det ikke at
 * ruten er lazy.
 *
 * Derfor bor adressene her, i en modul uten importer. Sidene setter fortsatt
 * `X.path` fra disse konstantene, så eksisterende bruk virker som før — men
 * `CRM.tsx` og menyene leser konstanten, ikke komponenten.
 */
export const routePaths = {
  profile: "/profile",
  settings: "/settings",
  changelog: "/changelog",
  tutorial: "/veiledning",
  reports: "/reports",
  prospects: "/prospects",
  agreements: "/agreements",
  weekPlan: "/oversikt/uke",
  prospectReport: "/prospects/report/:orgNr",
  companyReport: "/companies/:id/report",
  emailCompose: "/email",
  emailSentList: "/email/sent",
  emailSentShow: "/email/sent/:id",
  emailGroupsList: "/email/groups",
  emailGroupNew: "/email/groups/new",
  emailGroupEdit: "/email/groups/:id",
  emailTemplatesList: "/email/templates",
  emailTemplateNew: "/email/templates/new",
  emailTemplateEdit: "/email/templates/:id",
  emailDialog: "/email/dialog",
  emailDialogTab: "/email/dialog/:tab",
} as const;
